import Col from 'antd/lib/col'

import 'antd/lib/col/style'

export * from 'antd/lib/col'

export default Col
